export const state = () => ({
    cookiesPrivacy: false
})
export const getters = {
    cookiesPrivacy: (state) => {
        return state.cookiesPrivacy
    }
}

export const mutations = {
    SET_COOKIES_PRIVACY(state, data) {
        state.cookiesPrivacy = data
    },
}
